/* global Swiper, attachEvent */
// **********************************************************
// Gallery slider
// **********************************************************

const gallerySliderEle = document.querySelectorAll('[data-slider="gallery-slider"]');
const gallerySliderOpt = {
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
  },
};

gallerySliderEle.forEach((el) => {
  const gallerySliderParentEle = el.closest('.sc-gallery-slider');
  const arrowRight = gallerySliderParentEle.querySelector('.arrow-right');
  const arrowLeft = gallerySliderParentEle.querySelector('.arrow-left');
  gallerySliderOpt.navigation.nextEl = arrowRight;
  gallerySliderOpt.navigation.prevEl = arrowLeft;
  // eslint-disable-next-line no-new
  new Swiper(el, gallerySliderOpt);
});

// **********************************************************
// Gallery popup
// **********************************************************

attachEvent('.gallery-trigger', 'click', (ev) => {
  const parentElem = ev.target.closest('.sc-gallery-slider,.sc-banner');
  const galleryPopup = parentElem.querySelector('.gallery-popup');
  galleryPopup.classList.add('is-open-modal');
  document.body.classList.add('is-open-modal');
  ev.preventDefault();
});
